module.exports = __webpack_public_path__ + "static/media/calendar.58634ad3.jpg";